// extracted by mini-css-extract-plugin
export default {"nav":"navHeader_nav__9iIVw","logo":"navHeader_logo__HBfND"};